<template>
  <div class="publicItems2">
    <el-card style="margin-bottom: 20px" shadow="never">
      <div class="selectionArea">
        <div class="item">
          <span class="item_title">公众号</span>
          <el-autocomplete
            v-model="parameterNames.app_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入公众号"
            :clearable="true"
            @focus="current = '公众号'"
            @clear="app_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">投放组</span>
          <el-autocomplete
            v-model="parameterNames.release_group_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '投放组'"
            @select="handleSelect"
            @clear="release_group_id = null"
          />
        </div>
        <div class="item">
          <span class="item_title">投手</span>
          <el-autocomplete
            v-model="parameterNames.pitcher_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '投手'"
            @select="handleSelect"
            @clear="pitcher_id = null"
          />
        </div>
        <div class="item">
          <span class="item_title">运营组</span>
          <el-autocomplete
            v-model="parameterNames.operation_group_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '运营组'"
            @clear="operation_group_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">运营者</span>
          <el-autocomplete
            v-model="parameterNames.operation_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '运营者'"
            @clear="operation_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">平台</span>
          <el-autocomplete
            v-model="parameterNames.platform_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请选择平台"
            :clearable="true"
            @focus="current = '平台'"
            @clear="platform_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">书籍归属</span>
          <el-autocomplete
            v-model="parameterNames.book_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '书籍归属'"
            @clear="book_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">书籍类型</span>
          <!-- <el-autocomplete
          v-model="parameterNames.belong_type_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书籍类型'"
          @clear="belong_type = null"
          @select="handleSelect"
        /> -->
          <el-select
            v-model="parameterNames.belong_type_name"
            clearable
            filterable
            placeholder="请选择类型"
          >
            <el-option
              v-for="(item, index) in optionbook"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="item_title">书名</span>
          <el-autocomplete
            v-model="parameterNames.alias_book_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '书名'"
            @clear="alias_book_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">投放位置</span>
          <el-autocomplete
            v-model="parameterNames.position_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '投放位置'"
            @clear="position_id = null"
            @select="handleSelect"
          />
        </div>

        <div class="item">
          <span class="item_title">日期</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </div>
        <div v-if="currentDisplayType === 'chart'" class="item">
          <span class="item_title">投放平台类型</span>
          <el-select v-model="parameterNames.launch_platform_type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </div>
        <el-button
          style="height: 36px"
          type="primary"
          icon="el-icon-search"
          @click="search()"
        >搜索</el-button>
        <el-button
          style="height: 36px"
          type="default"
          icon="el-icon-refresh-left"
          @click="reset"
        >重置</el-button>
        <div class="right-box">
          <el-button
            v-if="currentDisplayType === 'chart'"
            style="height: 36px"
            type="plain"
            icon="el-icon-bottom"
            @click="reportExportnew"
          >导出总计报表新</el-button>
          <el-button
            v-else
            style="height: 36px"
            type="plain"
            icon="el-icon-bottom"
            @click="reportExport"
          >导出总计报表</el-button>
          <div class="style-tab">
            <div
              :class="{ 'active-bg': currentDisplayType === 'chart' }"
              @click="switchToChart"
            >
              <img
                src="../../assets/images/13.小说/liebiao.png"
                style="height: 25px;width: 26px;"
                alt=""
              >
              <div>新</div>
              <img
                src="../../assets/images/13.小说/liebiao.png"
                style="height: 25px;width: 26px;"
                alt=""
              >
            </div>
            <span>|</span>
            <div
              :class="{ 'active-bg': currentDisplayType === 'list' }"
              @click="switchToList"
            >
              <img
                src="../../assets/images/13.小说/tubiao.png"
                style="height: 25px;width: 26px;"
                alt=""
              >
              <div>旧</div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <!-- <el-card
      style="margin-bottom: 20px"
      class="set-btn"
    >
      <el-button
        style="height: 36px"
        type="plain"
        icon="el-icon-bottom"
        @click="reportExport"
      >导出总计报表</el-button>
      <div class="style-tab">
        <div
          class="style-tubiao"
          :class="{ 'active-bg': currentDisplayType === 'chart' }"
          @click="switchToChart"
        >
          <img
            src="../../assets/images/13.小说/liebiao.png"
            alt=""
          >
        </div>
        <span>|</span>
        <div
          class="style-liebiao"
          :class="{ 'active-bg': currentDisplayType === 'list' }"
          @click="switchToList"
        >
          <img
            src="../../assets/images/13.小说/tubiao.png"
            alt=""
          >
        </div>
      </div>
    </el-card> -->

    <el-card v-if="currentDisplayType === 'list'" shadow="never">
      <div class="contentnew">
        <div>合计</div>
        <div class="content-right">
          <div style="margin-right: 10px;">
            <div>新用户充值：</div>
            <div class="blue">
              {{
                tableData.total_data && tableData.total_data.new_user_recharge
                  ? tableData.total_data.new_user_recharge
                  : 0
              }}
            </div>
          </div>
          <div style="margin-right: 10px;">
            <div>消耗：</div>
            <div class="blue">
              {{
                tableData.total_data && tableData.total_data.total_consume
                  ? tableData.total_data.total_consume
                  : 0
              }}
            </div>
          </div>
          <div style="margin-right: 10px;">
            <div>新用户ROI：</div>
            <div class="blue">
              {{
                tableData.total_data && tableData.total_data.new_user_roi
                  ? tableData.total_data.new_user_roi
                  : 0
              }}
            </div>
          </div>
          <div style="margin-right: 10px;">
            <div>总充值ROI：</div>
            <div class="blue">
              {{
                tableData.total_data && tableData.total_data.total_user_roi
                  ? tableData.total_data.total_user_roi
                  : 0
              }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-table
          v-loading="loading"
          :data="tableData.list"
          max-height="650"
          style="width: 100%"
        >
          <el-table-column
            prop="channel_date"
            label="日期范围"
            width="150"
            align="center"
          />
          <el-table-column
            prop="release_group_name"
            label="投放组"
            width="120"
            align="center"
          />
          <el-table-column
            prop="operation_group_name"
            label="运营组"
            width="120"
            align="center"
          />
          <el-table-column
            prop="pitcher_name"
            label="投手姓名"
            align="center"
          />
          <el-table-column
            prop="platform_name"
            label="书城平台"
            width="120"
            align="center"
          />
          <el-table-column
            prop="position_name"
            label="投放位置"
          />
          <el-table-column
            prop="belong_name"
            label="归属书籍"
            width="120"
            align="center"
          />
          <el-table-column
            prop="belong_type"
            label="书籍类型"
            width="120"
            align="center"
          />
          <el-table-column
            prop="novel_name"
            label="书名"
            width="120"
            align="center"
          />
          <el-table-column
            prop="wechat_names"
            label="公众号名称"
            width="150"
            align="center"
          >
            <template scope="scope">
              <ExpandClose :my-values="JSON.parse(scope.row.wechat_names)" />
            </template>
          </el-table-column>
          <el-table-column
            prop="roi_standard"
            label="ROI标准"
            align="center"
          />
          <el-table-column
            prop="compliance_rate"
            label="ROI达标率"
            width="120"
            align="center"
          >
            <template scope="scope">
              {{ scope.row.compliance_rate }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="consume"
            label="总消耗"
            align="center"
          />
          <el-table-column
            prop="new_user_recharge_commission"
            label="新用户充值（扣除佣金）"
            width="180"
            align="center"
          />
          <el-table-column
            prop="new_user_roi"
            label="新用户ROI"
            width="120"
            align="center"
          >
            <template scope="scope">
              <span style="color: red; font-weight: bold">{{ scope.row.new_user_roi }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="total_recharge_commission"
            label="累积充值（扣除佣金）"
            width="180"
            align="center"
          />
          <el-table-column
            prop="today_back"
            label="总充值ROI"
            width="120"
            align="center"
          >
            <template scope="scope"> {{ scope.row.today_back }}% </template>
          </el-table-column>
          <el-table-column
            prop="payment_growth_rate"
            label="付费增长率"
            width="120"
            align="center"
          >
            <template scope="scope">{{ scope.row.payment_growth_rate }}%</template>
          </el-table-column>
          <el-table-column
            prop="merits"
            label="有效绩效"
            width="120"
            align="center"
          />
          <el-table-column
            prop="scan_follow_count"
            label="企微客服人数"
            width="120"
            align="center"
          />
          <el-table-column
            prop="scan_follow_cost"
            label="企微客服成本"
            width="120"
            align="center"
          />
          <el-table-column
            prop="from_follow_count"
            label="公众号关注人数"
            width="140"
            align="center"
          />
          <el-table-column
            prop="from_follow_cost"
            label="公众号关注成本"
            width="140"
            align="center"
          />
        </el-table>
      </div>

      <pagination-right
        :total="tableData.count"
        :page-sizes="[10]"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <div v-else>
      <el-card
        shadow="never"
        class="total-box"
      >
        <div style="display: flex;justify-content: space-between;">
          <!-- 1. 总成本 -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/chengben.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总消耗</div>
              <div>
                <span>￥</span>
                <count-to
                  :key="dataV2 ? dataV2.total_consume : 0"
                  :start-val="0"
                  :end-val="dataV2 ? Number(dataV2.total_consume) : 0"
                  :duration="1500"
                  :decimals="0"
                />
              </div>
            </div>
          </div>

          <!-- 2. 总充值 -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/chongzhi.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总新用户充值</div>
              <div>
                <span>￥</span>
                <count-to
                  :key="dataV2 ? dataV2.new_user_recharge : 0"
                  :start-val="0"
                  :end-val="dataV2 ? Number(dataV2.new_user_recharge) : 0"
                  :duration="1500"
                  :decimals="0"
                />
              </div>
            </div>
          </div>

          <!-- 3. 总回本率 (百分比，保留2位小数) -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/huiben.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总充值</div>
              <div>
                <span>￥</span>
                <count-to
                  :key="dataV2 ? dataV2.total_recharge : 0"
                  :start-val="0"
                  :end-val="dataV2 ? Number(dataV2.total_recharge) : 0"
                  :duration="1500"
                  :decimals="2"
                />
              </div>
            </div>
          </div>

          <!-- 4. 增长率 (百分比，保留2位小数) -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/newyonghu.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>新用户 ROI</div>
              <div>
                <!-- <count-to
                  :key="dataV2 ? dataV2.new_user_roi : 0"
                  :start-val="0"
                  :end-val="dataV2 ? Number(dataV2.new_user_roi) : 0"
                  :duration="1500"
                  :decimals="2"
                /> -->
                <!-- <span>%</span> -->
                <div>{{ dataV2.new_user_roi }}</div>
              </div>
            </div>
          </div>
          <!-- 5. 增长率 (百分比，保留2位小数) -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/zengzhang.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总充值 ROI</div>
              <div style="display:flex">
                <!-- <count-to
                  :key="dataV2 ? dataV2.total_user_roi : 0"
                  :start-val="0"
                  :end-val="dataV2 ? Number(dataV2.total_user_roi) : 0"
                  :duration="1500"
                  :decimals="2"
                /> -->
                <div>{{ dataV2.total_user_roi }}</div>
              <!-- <span>%</span> -->
              </div>
            </div>
          </div>
        </div>

      </el-card>
      <el-card style="margin-top:16px" shadow="never">
        <!-- 图表容器 （示例4个） -->
        <div class="chart-layout">
          <div class="item" style="background-color: #FFFFFF;text-align: right;width: 100%">
            <span style="margin-right: 10px">投放组:</span>
            <el-autocomplete
              v-model="parameterNames.release_group_id_name"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入内容"
              :clearable="true"
              @focus="current = '投放组'"
              @select="handleSelect"
              @clear="release_group_id = null"
            />
          </div>
          <div
            v-if="currentDisplayType == 'chart'"
            ref="chart1"
            class="chart-item"
          />
        </div>
      </el-card>
      <el-card style="margin-top:16px" shadow="never">
        <div style="display:flex">

          <div
            v-if="currentDisplayType == 'chart'"
            ref="chart2"
            class="chart-item"
            style="width: 60vw"
          />

          <div>
            <div style="margin-bottom:20px">公众号关注数据</div>
            <div>
              <el-table
                :data="newtabledatatwo"
                border
                style="width: 100%"
                max-height="400"
              >

                <el-table-column
                  prop="app_name"
                  label="公众号名称"
                  width="150"
                  align="center"
                />
                <el-table-column
                  prop="pitcher_name"
                  label="投手名称"
                  width="150"
                  align="center"
                />
                <el-table-column
                  prop="scan_follow_cost"
                  label="企微客服成本"
                  width="130"
                  align="center"
                />
                <el-table-column
                  prop="scan_follow_count"
                  label="企微客服人数"
                  align="center"
                  width="130"
                />
                <el-table-column
                  prop="from_follow_cost"
                  label="公众号关注的成本"
                  width="150"
                  align="center"
                />
                <el-table-column
                  prop="from_follow_count"
                  label="公众号关注的数量"
                  align="center"
                />
              </el-table>
              <pagination-right
                :total="newcounttwo"
                :page-sizes="[10]"
                @size-change="fetchPageSizenewtwo"
                @current-change="fetchCurrentPagenewtwo"
              />
            </div>
          </div>
        </div>
      </el-card>
      <el-card style="margin-top:20px" shadow="never">
        <div style="display:flex">
          <div
            ref="chart5"
            style="width:43.5vw !important"
            class="chart-item"
          />
          <div
            ref="chart3"
            style="width:43.5vw !important"
            class="chart-item"
          />
        </div>

      </el-card>
      <el-card style="margin-top:20px" shadow="never">
        <div style="display:flex">
          <div
            ref="chart4"
            style="width:43.5vw !important"
            class="chart-item"
          />
          <div
            ref="chart6"
            style="width:43.5vw !important"
            class="chart-item"
          />
        </div>

      </el-card>
      <el-card style="margin-top:16px" shadow="never">
        <el-table
          :data="newtabledata"
          max-height="650"
          style="width: 100%"
        >
          <el-table-column
            prop="channel_date"
            label="日期范围"
            width="150"
            align="center"
          />
          <el-table-column
            prop="release_group_name"
            label="投放组"
            width="120"
            align="center"
          />
          <el-table-column
            prop="operation_group_name"
            label="运营组"
            width="120"
            align="center"
          />
          <el-table-column
            prop="pitcher_name"
            label="投手姓名"
            align="center"
          />
          <el-table-column
            prop="platform_name"
            label="书城平台"
            width="120"
            align="center"
          />
          <el-table-column
            prop="position_name"
            label="投放位置"
          />
          <el-table-column
            prop="belong_name"
            label="归属书籍"
            width="120"
            align="center"
          />
          <el-table-column
            prop="belong_type"
            label="书籍类型"
            width="120"
            align="center"
          />
          <el-table-column
            prop="novel_name"
            label="书名"
            width="120"
            align="center"
          />
          <el-table-column
            prop="wechat_names"
            label="公众号名称"
            width="150"
            align="center"
          >
            <template scope="scope">
              <ExpandClose :my-values="JSON.parse(scope.row.wechat_names)" />
            </template>
          </el-table-column>
          <el-table-column
            prop="roi_standard"
            label="ROI标准"
            align="center"
          />
          <el-table-column
            prop="compliance_rate"
            label="ROI达标率"
            width="120"
            align="center"
          >
            <template scope="scope">
              {{ scope.row.compliance_rate }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="consume"
            label="总消耗"
            align="center"
          />
          <el-table-column
            prop="new_user_recharge_commission"
            label="新用户充值（扣除佣金）"
            width="180"
            align="center"
          />
          <el-table-column
            prop="new_user_roi"
            label="新用户ROI"
            width="120"
            align="center"
          >
            <template scope="scope">
              <span style="color: red; font-weight: bold">{{ scope.row.new_user_roi }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="total_recharge_commission"
            label="累积充值（扣除佣金）"
            width="180"
            align="center"
          />
          <el-table-column
            prop="today_back"
            label="总充值ROI"
            width="120"
            align="center"
          >
            <template scope="scope"> {{ scope.row.today_back }}% </template>
          </el-table-column>
          <el-table-column
            prop="payment_growth_rate"
            label="付费增长率"
            width="120"
            align="center"
          >
            <template scope="scope">{{ scope.row.payment_growth_rate }}%</template>
          </el-table-column>
          <el-table-column
            prop="merits"
            label="有效绩效"
            width="120"
            align="center"
          />
          <el-table-column
            prop="scan_follow_count"
            label="企微客服人数"
            width="120"
            align="center"
          />
          <el-table-column
            prop="scan_follow_cost"
            label="企微客服成本"
            width="120"
            align="center"
          />
          <el-table-column
            prop="from_follow_count"
            label="公众号关注人数"
            width="140"
            align="center"
          />
          <el-table-column
            prop="from_follow_cost"
            label="公众号关注成本"
            width="140"
            align="center"
          />
        </el-table>
        <pagination-right
          :total="newcount"
          :page-sizes="[10]"
          @size-change="fetchPageSizenew"
          @current-change="fetchCurrentPagenew"
        />
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  getTotalReportList,
  getTheListOfOfficialAccount,
  getReleaseGroupList,
  getListOfPitchersInTheLaunchGroup,
  getOperationGroupList,
  getOperatorList,
  getTitleList,
  getBookOwnershipList,
  dropLocationList,
  modifyConsumption,
  exportTotalReport,
  updateReleaseBookType,
  bindwechattotallist,
  releasereportv2followlist,
  releasereportv2graphicsdata,
  exportTotalReportnew
} from '@/api/releaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ExpandClose from '@/components/ExpandClose/index.vue'
import { getSelectList } from '@/api/report/SelectData.js'
import CountTo from 'vue-count-to'
import * as echarts from 'echarts'
import { commonreportoptions } from '@/api/copyReleaseGroup.js'
export default {
  components: {
    PaginationRight,
    ExpandClose,
    CountTo
    /* Details */
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        app_id: null,
        release_group_id: null,
        pitcher_id: null,
        operation_group_id: null,
        operation_id: null,
        alias_book_id: null,
        book_id: null,
        belong_type: null,
        position_id: null,
        platform_id: null
      },
      parameterNames: {
        app_id_name: null, // 公众号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        belong_type_name: null,
        position_id_name: null, // 投放位置
        platform_name: null,
        launch_platform_type: ''
      },
      current: null,
      date: [],
      activeItem: null,
      activeText: null,
      drawerItem: {},
      optionbook: [],
      currentDisplayType: 'list', // 用于控制列表/图表显示模式
      dataV2: {},
      chart: null,
      // 图表数据
      mockList: [],
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      chart5: null,
      chart6: null,
      newtabledata: [],
      newcount: null,

      newtabledatatwo: [],
      newcounttwo: null,
      pieData: [
        { name: '阳光书城', value: 1234 },
        { name: '阅文', value: 856 },
        { name: '文鼎', value: 437 },
        { name: '万读', value: 968 },
        { name: '海读', value: 742 }
      ],
      options: [
        {
          value: 1,
          label: '腾讯'
        }, {
          value: 2,
          label: '巨量'
        }
      ]
    }
  },
  created() {
    window.aa = this
    this.oplistr()
    if (this.currentDisplayType === 'chart') {
      this.newlist()
      this.newlisttwo()
      this.chartlist()
      // this.fetchMockData()
    } else {
      this.getDataList()
    }
    if (this.optionbook.length >= 0) {
      this.booktypeList()
    }
  },
  methods: {
    async booktypeList() {
      const res = await updateReleaseBookType()
      this.optionbook = res.data
    },
    // 获取数据列表
    async getDataList(obj = {}) {
      this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await getTotalReportList({
        ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.drawerItem = row
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.search(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.search(true)
    },

    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        公众号: 'account_name',
        投放组: 'release_group_name',
        投手: 'user_name',
        运营组: 'operation_group_name',
        运营者: 'user_name',
        书籍归属: 'book_name',
        书名: 'novel_name',
        投放位置: 'position_name'
      }

      switch (this.current) {
        case '公众号':
          currentFunc = getTheListOfOfficialAccount
          break
        case '投放组':
          currentFunc = getReleaseGroupList
          break
        case '投手':
          currentFunc = getListOfPitchersInTheLaunchGroup
          break
        case '运营组':
          currentFunc = getOperationGroupList
          break
        case '运营者':
          currentFunc = getOperatorList
          break
        case '书名':
          currentFunc = getTitleList
          break
        case '书籍类型':
          currentFunc = updateReleaseBookType
          break
        case '书籍归属':
          currentFunc = getBookOwnershipList
          break
        case '投放位置':
          currentFunc = dropLocationList
          break
        case '平台':
          currentFunc = getSelectList
          break
      }
      if (!currentFunc) {
        return
      }
      if ((this.current === '投手' && !this.parameter.release_group_id) || (this.current === '运营者' && !this.parameter.operation_group_id) || (this.current === '书名' && !this.parameter.book_id)) {
        const obj1 = {
          投手: '请先选投放组，才能选投手',
          运营者: '请先选运营组，才能选运营者',
          书名: '请先选择书籍归属，才能选书名'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: queryString || null,
        group_id: this.current === '投手' ? this.parameter.release_group_id.address : this.current === '运营者' ? this.parameter.operation_group_id.address : null,
        book_belong_id: this.parameter.book_id ? this.parameter.book_id.address : null,
        type: this.current === '投放组' ? 2 : null
      })
      console.log(data)
      if (this.current === '书籍类型') {
        cb(
          data.data.map(item => {
            return {
              value: item,
              address: item
            }
          })
        )
        return
      }
      if (this.current === '平台') {
        cb(
          data.data.platform.map(item => {
            return {
              value: item.name,
              address: item.id
            }
          })
        )
        return
      }
      if (this.current === '投手') {
        cb(
          data.data.group_user.map(item => {
            return {
              value: item.nickname,
              address: item.bind_id
            }
          })
        )
        return
      }
      cb(
        data.data.list.map(item => {
          return {
            value: item[obj[this.current]],
            address: this.current === '公众号' ? item.app_id : item.id
          }
        })
      )
    },

    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '公众号':
          this.parameter.app_id = item
          break
        case '投放组':
          this.parameter.release_group_id = item
          this.search()
          break
        case '投手':
          this.parameter.pitcher_id = item
          break
        case '运营组':
          this.parameter.operation_group_id = item
          break
        case '运营者':
          this.parameter.operation_id = item
          break
        case '书名':
          this.parameter.alias_book_id = item
          break
        case '书籍归属':
          this.parameter.book_id = item
          break
        case '书籍类型':
          this.parameter.belong_type = item
          break
        case '投放位置':
          this.parameter.position_id = item
          break
        case '平台':
          this.parameter.platform_id = item
          break
      }
    },

    // 搜索
    search(value) {
      value || (this.parameter.page = 1)
      const obj = {
        app_id: 'app_id_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        belong_type: 'belong_type_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && this.parameter[key].value === this.parameterNames[obj[key]] && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }
      obj1.launch_platform_type = this.parameterNames.launch_platform_type
      if (value === '导出') {
        return obj1
      } else {
        if (this.currentDisplayType === 'chart') {
          this.newlist(obj1)
          this.newlisttwo(obj1)
          this.chartlist(obj1)
        } else {
          this.getDataList(obj1)
        }
      }
      // value === '导出' || this.getDataList(obj1)
      // return obj1
    },

    // 重置
    reset(value) {
      this.parameter = {
        page: 1,
        page_size: 10,
        app_id: null,
        release_group_id: null,
        pitcher_id: null,
        operation_group_id: null,
        operation_id: null,
        alias_book_id: null,
        book_id: null,
        belong_type: null,
        position_id: null,
        platform_id: null
      }
      this.parameterNames = {
        app_id_name: null, // 公众号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        belong_type_name: null,
        position_id_name: null, // 投放位置
        platform_name: null,
        launch_platform_type: ''
      }
      this.date = []
      this.current = null
      if (this.currentDisplayType === 'chart') {
        this.newlist()
        this.newlisttwo()
        this.chartlist()
      } else {
        this.getDataList()
      }
    },

    // 导出报表
    async reportExport() {
      const obj = this.search('导出')
      await exportTotalReport({
        ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      this.reset('no')
    },
    // 导出报表
    async reportExportnew() {
      const obj = this.search('导出')
      await exportTotalReportnew({
        ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      this.reset('no')
    },

    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await modifyConsumption({
            id: this.activeItem.id,
            consume: this.activeText
          })
          this.$message({
            message: '修改消耗成功',
            type: 'success'
          })
          this.getDataList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },
    switchToChart() {
      this.currentDisplayType = 'chart'
      // 如果已经有值了，就不处理
      if (this.parameterNames.release_group_id_name) {
        this.search(true)
        return
      }
      // 设置当前 focus 类型
      this.current = '投放组'
      // 主动调用一次查询函数
      // getReleaseGroupList({ name: null, type: 2 }).then((data) => {
      //   if (data?.data?.list?.length) {
      //     const firstItem = data.data.list[0]
      //
      //     // 设置显示值（v-model 绑定）
      //     this.parameterNames.release_group_id_name = firstItem.release_group_name
      //
      //     // 设置投放组 ID，用于级联逻辑
      //     this.release_group_id = {
      //       value: firstItem.release_group_name,
      //       address: firstItem.id
      //     }
      //
      //     // 设置 parameter 里的值（你 querySearchAsync 判断依赖这个）
      //     this.parameter.release_group_id = this.release_group_id
      //
      //     this.search(true)
      //   }
      // })
    },
    switchToList() {
      this.currentDisplayType = 'list'
      this.search(true)
    },
    async newlist(obj = {}) {
      // this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await bindwechattotallist({
        ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      console.log('data', data)
      this.dataV2 = data.data.total_data
      this.newtabledata = data.data.list
      this.newcount = data.data.count
      // this.tableData = data.data
      // this.loading = false
    },
    // 分页
    fetchPageSizenew(s) {
      this.parameter.page_size = s
      const obj = {
        app_id: 'app_id_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        belong_type: 'belong_type_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && this.parameter[key].value === this.parameterNames[obj[key]] && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }
      this.newlist(obj1)
    },

    // 分页
    fetchCurrentPagenew(s) {
      this.parameter.page = s
      const obj = {
        app_id: 'app_id_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        belong_type: 'belong_type_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && this.parameter[key].value === this.parameterNames[obj[key]] && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }
      this.newlist(obj1)
    },

    async newlisttwo(obj = {}) {
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await releasereportv2followlist({
        ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      console.log('公众号关注数据', data.data.list)
      this.newtabledatatwo = data.data.list
      this.newcounttwo = data.data.count
    },
    // 分页
    fetchPageSizenewtwo(s) {
      this.parameter.page_size = s
      const obj = {
        app_id: 'app_id_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        belong_type: 'belong_type_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && this.parameter[key].value === this.parameterNames[obj[key]] && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }
      this.newlisttwo(obj1)
    },

    // 分页
    fetchCurrentPagenewtwo(s) {
      this.parameter.page = s
      const obj = {
        app_id: 'app_id_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        belong_type: 'belong_type_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && this.parameter[key].value === this.parameterNames[obj[key]] && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }
      this.newlisttwo(obj1)
    },

    // 获取图表数据
    async chartlist(obj = {}) {
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await releasereportv2graphicsdata({
        ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      console.log('图表', data.data)
      console.log('111', data.data.platform_statistics)
      console.log('222', data.data.platform_statistics)
      this.disposeAllCharts()

      this.chart1 = echarts.init(this.$refs.chart1)
      this.chart1.setOption(this.getRechargeOption(data.data.new_user_roi_list))

      // 图2: 每日成本
      this.chart2 = echarts.init(this.$refs.chart2)
      this.chart2.setOption(this.getCostOption(data.data.new_user_recharge_commission_list, data.data.total_recharge_commission_list))

      // 图3: 每日利润
      this.chart3 = echarts.init(this.$refs.chart3)
      this.chart3.setOption(this.getProfitOption(data.data.total_recharge_roi_list))

      // 图4: 回本率
      this.chart4 = echarts.init(this.$refs.chart4)
      this.chart4.setOption(this.getRateOption(data.data.profitability_list))

      // 图6: 666
      this.chart6 = echarts.init(this.$refs.chart6)
      this.chart6.setOption(this.getRateOptionsr(data.data.platform_statistics, data.data.total_platform_data_count))

      if (this.$refs.chart5) {
        this.chart5 = echarts.init(this.$refs.chart5)
        this.chart5.setOption(this.getRechargeBarOption(data.data.consume_list))
      }
      // 监听窗口大小变化，自适应
      window.addEventListener('resize', this.handleResize)
    },

    rand(min, max) {
      // 小工具：闭区间随机整数
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    fetchMockData() {
      const days = 7
      const tmp = []

      for (let i = 0; i < days; i++) {
        const dateStr = this.getDateOffset(i)

        const rechargeVal = this.rand(100, 1500)
        const costVal = this.rand(50, 800)
        const profitVal = rechargeVal - costVal
        const rateVal = +(costVal ? (profitVal / costVal) * 100 : 0).toFixed(2)

        tmp.push({
          date: dateStr,
          recharge: rechargeVal,
          cost: costVal,
          profit: profitVal,
          rate: rateVal,
          /* 下面 6 个用于柱状图 */
          day3: this.rand(100, 1500),
          day7: this.rand(100, 1500),
          day15: this.rand(100, 1500),
          day30: this.rand(100, 1500),
          day45: this.rand(100, 1500),
          day60: this.rand(100, 1500)
        })
      }

      this.mockList = tmp
      this.$nextTick(() => this.renderAllCharts())
    },

    /**
     * 2. 根据 offset 生成日期字符串 (如 "2023-04-08")
     */
    getDateOffset(offset) {
      const d = new Date()
      d.setDate(d.getDate() - offset) // 向前推 offset 天
      const y = d.getFullYear()
      let m = d.getMonth() + 1
      let day = d.getDate()
      if (m < 10) m = '0' + m
      if (day < 10) day = '0' + day
      return `${y}-${m}-${day}`
    },

    /**
     * 3. 初始化并渲染 4 个图表
     */
    renderAllCharts() {
      // 渲染前先销毁，防止重复初始化
      console.log('chart1 ref:', this.$refs.chart1)
      this.disposeAllCharts()
      console.log('chart1 ref:', this.$refs.chart1)

      // 图1: 每日充值
      // this.chart1 = echarts.init(this.$refs.chart1)
      // this.chart1.setOption(this.getRechargeOption())

      // 图2: 每日成本
      // this.chart2 = echarts.init(this.$refs.chart2)
      // this.chart2.setOption(this.getCostOption())

      // 图3: 每日利润
      // this.chart3 = echarts.init(this.$refs.chart3)
      // this.chart3.setOption(this.getProfitOption())

      // 图4: 回本率
      // this.chart4 = echarts.init(this.$refs.chart4)
      // this.chart4.setOption(this.getRateOption())

      // 图6: 666
      // this.chart6 = echarts.init(this.$refs.chart6)
      // this.chart6.setOption(this.getRateOptionsr())

      // if (this.$refs.chart5) {
      //   this.chart5 = echarts.init(this.$refs.chart5)
      //   this.chart5.setOption(this.getRechargeBarOption())
      // }
      // 监听窗口大小变化，自适应
      window.addEventListener('resize', this.handleResize)
    },
    disposeAllCharts() {
      if (this.chart1) {
        this.chart1.dispose()
        this.chart1 = null
      }
      if (this.chart2) {
        this.chart2.dispose()
        this.chart2 = null
      }
      if (this.chart3) {
        this.chart3.dispose()
        this.chart3 = null
      }
      if (this.chart4) {
        this.chart4.dispose()
        this.chart4 = null
      }
      if (this.chart5) {
        this.chart5.dispose()
        this.chart5 = null
      }
      if (this.chart6) {
        this.chart6.dispose()
        this.chart6 = null
      }
      window.removeEventListener('resize', this.handleResize)
    },
    handleResize() {
      this.chart1 && this.chart1.resize()
      this.chart2 && this.chart2.resize()
      this.chart3 && this.chart3.resize()
      this.chart4 && this.chart4.resize()
      this.chart5 && this.chart5.resize()
      this.chart6 && this.chart6.resize()
    },

    /**
     * 1. 累积充值 (使用 #008DFF)
     */
    getRechargeOption(new_user_roi_list) {
      // const xData = this.mockList.map(item => item.date)
      // const yData = this.mockList.map(item => item.recharge)
      // console.log('xData', yData, xData)
      const xData = new_user_roi_list.map(item => item.name)
      const yData = new_user_roi_list.map(item => Number(item.value))
      return {
        title: { text: '新用户ROI' },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            const item = params[0] // 只取第一个序列
            return item.name + '<br/>ROI: ' + item.value + '%'
          }
        },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: 'ROI',
            type: 'line',
            smooth: false, // 平滑曲线
            symbol: 'circle', // 拐点形状
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF' // 主色
            },
            itemStyle: {
              color: '#008DFF', // 拐点颜色
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              // 区域渐变 (顶部不透明, 底部透明)
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              show: false,
              formatter: '{c}%'
            }
          }
        ]
      }
    },

    getCostOption(new_user_recharge_commission_list, total_recharge_commission_list) {
      // const xData = this.mockList.map(item => item.date)
      // const yData = this.mockList.map(item => item.cost)
      // return {
      //   title: { text: '成本（元）' },
      //   tooltip: { trigger: 'axis' },
      //   xAxis: {
      //     type: 'category',
      //     data: xData,
      //     axisLine: { lineStyle: { color: '#E0E0E0' } },
      //     axisTick: { show: false },
      //     splitLine: { show: false }
      //   },
      //   yAxis: {
      //     type: 'value',
      //     axisLine: { show: false },
      //     axisTick: { show: false },
      //     splitLine: {
      //       lineStyle: {
      //         type: 'dashed',
      //         color: '#E0E0E0'
      //       }
      //     }
      //   },
      //   grid: {
      //     left: 40,
      //     right: 20,
      //     top: 40,
      //     bottom: 30
      //   },
      //   series: [
      //     {
      //       name: '成本',
      //       type: 'line',
      //       smooth: false,
      //       symbol: 'circle',
      //       symbolSize: 6,
      //       data: yData,
      //       lineStyle: {
      //         width: 2,
      //         color: '#5FE1E0'
      //       },
      //       itemStyle: {
      //         color: '#5FE1E0',
      //         borderColor: '#fff',
      //         borderWidth: 1
      //       },
      //       areaStyle: {
      //         color: new echarts.graphic.LinearGradient(
      //           0,
      //           0,
      //           0,
      //           1,
      //           [
      //             { offset: 0, color: 'rgba(95,225,224,0.4)' },
      //             { offset: 1, color: 'rgba(95,225,224,0)' }
      //           ],
      //           false
      //         )
      //       },
      //       label: {
      //         show: true,
      //         formatter: '{c}元'
      //       }
      //     }
      //   ]
      // }
      const nameSet = new Set()
      new_user_recharge_commission_list.forEach(item => nameSet.add(item.name))
      total_recharge_commission_list.forEach(item => nameSet.add(item.name))

      const userNames = Array.from(nameSet)

      const newUserMap = Object.fromEntries(new_user_recharge_commission_list.map(item => [item.name, parseFloat(item.value)]))
      const totalMap = Object.fromEntries(total_recharge_commission_list.map(item => [item.name, parseFloat(item.value)]))

      const newUserValues = userNames.map(name => newUserMap[name] ?? null)
      const totalValues = userNames.map(name => totalMap[name] ?? null)

      return {
        title: { text: '新用户充值（扣除佣金）  累计充值（扣除佣金）', top: 5 },
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let html = `${params[0].axisValue}<br/>`
            params.forEach(item => {
              html += `
            <span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${item.color};"></span>
            ${item.seriesName}：${item.value ?? '-'} 元<br/>
          `
            })
            return html
          }
        },
        legend: {
          data: ['新用户充值（扣除佣金）', '累计充值（扣除佣金）'],
          top: 50
        },
        grid: {
          left: 40,
          right: 20,
          top: 90,
          bottom: 30
        },
        xAxis: {
          type: 'category',
          data: userNames,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        series: [
          {
            name: '新用户充值（扣除佣金）',
            type: 'line',
            data: newUserValues,
            lineStyle: { width: 2, color: '#008DFF' },
            itemStyle: {
              color: '#008DFF',
              borderColor: '#fff',
              borderWidth: 1
            },
            symbol: 'circle',
            symbolSize: 6,
            label: {
              show: false,
              formatter: '{c}元'
            }
          },
          {
            name: '累计充值（扣除佣金）',
            type: 'line',
            data: totalValues,
            lineStyle: { width: 2, color: '#5FE1E0' },
            itemStyle: {
              color: '#5FE1E0',
              borderColor: '#fff',
              borderWidth: 1
            },
            symbol: 'circle',
            symbolSize: 6,
            label: {
              show: false,
              formatter: '{c}元'
            }
          }
        ]
      }
    },

    /**
     * 3. 每日利润 (使用 #5FE1E0)
     */
    getProfitOption(total_recharge_roi_list) {
      // const xData = this.mockList.map(item => item.date)
      // const yData = this.mockList.map(item => item.profit)
      const xData = total_recharge_roi_list.map(item => item.name)
      const yData = total_recharge_roi_list.map(item => Number(item.value))
      return {
        title: { text: '总充值roi（%）' },
        // tooltip: { trigger: 'axis' },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            const item = params[0] // 只取第一个序列
            return item.name + '<br/>ROI: ' + item.value + '%'
          }
        },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '利润',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#5FE1E0'
            },
            itemStyle: {
              color: '#5FE1E0',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  { offset: 0, color: 'rgba(95,225,224,0.4)' },
                  { offset: 1, color: 'rgba(95,225,224,0)' }
                ],
                false
              )
            },
            label: {
              show: false,
              formatter: '{c}%'
            }
          }
        ]
      }
    },

    /**
     * 4. 回本率 (使用 #008DFF)
     */
    getRateOption(profitability_list) {
      const xData = profitability_list.map(item => item.name)
      const yData = profitability_list.map(item => Number(item.value))
      console.log(xData, yData)
      return {
        title: { text: '利润（元）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          },
          axisLabel: {
            formatter: '{value}元'
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '利润（元）',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF'
            },
            itemStyle: {
              color: '#008DFF',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              show: false,
              formatter: '{c}元'
            }
          }
        ]
      }
    },
    getRateOptionsr(platform_statistics, total_platform_data_count) {
      const total = platform_statistics.reduce((sum, item) => sum + Number(item.value), 0)
      const pieData = platform_statistics.map(item => ({
        name: item.name,
        value: Number(item.value)
      }))

      return {
        // title: {
        //   text: '书城平台\n' + total_platform_data_count,
        //   left: 'center',
        //   top: '42%',
        //   textStyle: {
        //     fontSize: 14,
        //     fontWeight: 'normal',
        //     lineHeight: 22,
        //     color: '#333',
        //     rich: {
        //       a: { fontSize: 16, fontWeight: 'bold' }
        //     }
        //   }
        // },
        title: {
          text: `{a|书城平台}\n{b|${total_platform_data_count}}`,
          left: '31%', // 与 series.center[0] 一致
          top: '45%', // 可以微调这个值，居中效果更好
          textStyle: {
            rich: {
              a: {
                fontSize: 14,
                color: '#666',
                align: 'center',
                lineHeight: 22
              },
              b: {
                fontSize: 20,
                fontWeight: 'bold',
                color: '#333',
                align: 'center',
                lineHeight: 28
              }
            }
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 20,
          top: 'center',
          itemGap: 16,
          textStyle: {
            fontSize: 12,
            color: '#666'
          },
          formatter: name => {
            const item = pieData.find(i => i.name === name)
            const percent = ((item.value / total) * 100).toFixed(2)
            return `${name}  ${percent}%`
          }
        },
        series: [
          {
            name: '投放平台',
            type: 'pie',
            radius: ['55%', '75%'],
            center: ['35%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            data: pieData,
            color: ['#4DB6E2', '#00C1D4', '#5E83FB', '#008DFF', '#D3DCE6']
          }
        ]
      }
    },
    /**
     * 5. 表格 (使用 #008DFF)
     */

    getRechargeBarOption(consume_list) {
      const xData = consume_list.map(item => item.name)
      const yData = consume_list.map(item => Number(item.value))

      const barGradient = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: '#008DFF' },
        { offset: 1, color: 'rgba(0,141,255,0.5)' }
      ])

      return {
        title: { text: '总消耗（元）' },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: params => {
            const item = params[0]
            const colorDot = `<span style="display:inline-block;margin-right:6px;
          border-radius:50%;width:10px;height:10px;
          background:linear-gradient(180deg,#008DFF 0%,rgba(0,141,255,0.5) 100%)">
        </span>`
            return `${item.name}<br/>${colorDot}总消耗：${item.value} 元`
          }
        },
        legend: {
          show: false
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          },
          axisLine: { show: false },
          axisTick: { show: false }
        },
        series: [
          {
            name: '总消耗',
            type: 'bar',
            barWidth: 20,
            data: yData,
            itemStyle: {
              color: barGradient
            },
            label: {
              show: false,
              position: 'top',
              formatter: '{c} 元'
            }
          }
        ]
      }
    },
    async oplistr() {
      const res = await commonreportoptions()
      this.options = res.data.launch_platform_type
    }
  }
}
</script>
<style scoped lang="less">
.publicItems2{
  padding: 24px;
}
.content {
  .item {
    display: flex;
    align-items: center;
    .item_title {
      display: inline-block;
      width: 100px;
    }
    .item_input {
      width: 200px;
    }
  }
}

.selectionArea {
  display: flex;
  flex-wrap: wrap;
  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title {
      margin-right: 10px;
      display: inline-block;
    }
    .item_input {
      width: 200px;
    }
  }
  .right-box {
    margin-left: auto;  // 自动推到最右边
    text-align: right;
    display: flex;
  }
}

.powder {
  background: rgb(248, 216, 216);
}
.green {
  background: rgb(52, 229, 54);
}
.yellow {
  background: rgb(255, 247, 173);
}

.red {
  background: #ffa500;
}
.magRig {
  margin-right: 10px;
}
.magLfte {
  margin-left: 10px;
}
.chong {
  display: inline-block;
  width: 13px;
  height: 86%;
  margin-left: 6px;
}
.mybox {
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.publicItems2 .el-dialog {
  margin-top: 6vh !important;
}

.contentnew {
  color: #1d2129;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  margin-bottom: 20px;

  .content-right {
    display: flex;
    div {
      display: flex;
      align-items: center;

      div:first-of-type {
        margin-left: 30px;
      }
    }
  }
}
.set-btn .el-card__body {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.total-cell {
  width: 200px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  .total-img {
    img {
      width: 56px;
      height: 56px;
    }
  }
  .total-data {
    font-size: 18px;
    color: #1d2129;
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-left: 10px;
    justify-content: space-between;

    div:nth-of-type(1) {
      font-size: 16px;
      color: #4e5969;
    }
    div:nth-of-type(2) {
      font-weight: bold;
    }
    span {
      font-size: 16px;
    }
  }
}

.report-demo {
  padding: 20px;
}
.chart-layout {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background-color: #f1f2f5;
}
.charts-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.chart-box {
  width: 48%;
  height: 300px;
  border: 1px solid #eee;
  position: relative;
}
.chart-item {
  width: 43.5vw;
  height: 426px !important;
  padding: 20px;
  border-radius: 5px;
  background: #fff;
}
/* 让 table 自动平分列宽 */
.daily-table .el-table__header-wrapper table,
.daily-table .el-table__body-wrapper table {
  table-layout: fixed;
  width: 100%;
}

/* 隐藏所有竖线（单元格右侧的默认边框） */
.daily-table .el-table__header-wrapper th,
.daily-table .el-table__body-wrapper td {
  border-right: none !important;
}

/* 只保留行底部横线 */
.daily-table .el-table__body-wrapper tr {
  border-bottom: 1px solid #ebeef5; /* 根据设计稿调整颜色 */
}

/* 也给表头加一条横线，分隔标题和内容 */
.daily-table .el-table__header-wrapper tr {
  border-bottom: 1px solid #ebeef5;
}
.total-box {
  margin-bottom: 0px;
}
.chart-item:last-of-type {
  width: 100% !important;
}
.header-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 表头背景色 & 居中 */
.daily-table ::v-deep .el-table__header-wrapper th {
  background-color: #f5f7fa !important;
  text-align: center !important;
}

/* 表格内容居中 */
.daily-table ::v-deep .el-table__body-wrapper td {
  text-align: center !important;
}
.header-title {
  font-size: 18px;
  font-weight: bold;
}
.header-more-btn {
  font-size: 14px;
  color: #86909c;
  position: absolute;
  right: 20px;
}
.style-tab {
  width: 124px;
  height: 36px;
  background-color: #f2f3f5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  div {
    width: 42px;
    height: 24px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    img {
      width: 16px;
      height: 16px;
    }
  }
  span {
    margin: 0px 5px;
    color: #ccc;
  }
}
/* 当处于激活状态时，设置背景为白色 */
.active-bg {
  background-color: #ffffff;
}
.blue{
  font-size: 18px;
  color: red;
}

.selectionArea {
  @success-rgb: 0, 180, 42;
  @warning-rgb: 255, 125, 0;

  /* 针对 type 为 success 的按钮（plain 或非 plain）*/
  /deep/ .el-button--success,
  /deep/ .el-button--success.is-plain {
    background-color: rgba(@success-rgb, 0.08) !important;
    color: #00B42A !important;
    border: 1px solid #00B42A !important;
    border-radius: 4px !important;
    height: 37px !important;
    padding: 0 10px !important;
  }
  /deep/ .el-button--success:hover,
  /deep/ .el-button--success.is-plain:hover { background-color: rgba(@success-rgb, 0.15) !important; }
  /deep/ .el-button--success:active,
  /deep/ .el-button--success.is-active { background-color: rgba(@success-rgb, 0.25) !important; }

  /* warning 同理 */
  /deep/ .el-button--warning,
  /deep/ .el-button--warning.is-plain {
    background-color: rgba(@warning-rgb, 0.08) !important;
    color: #FF7D00 !important;
    border: 1px solid #FF7D00 !important;
    border-radius: 4px !important;
    height: 37px !important;
    padding: 0 10px !important;
  }
  /deep/ .el-button--warning:hover,
  /deep/ .el-button--warning.is-plain:hover { background-color: rgba(@warning-rgb, 0.15) !important; }
  /deep/ .el-button--warning:active,
  /deep/ .el-button--warning.is-active { background-color: rgba(@warning-rgb, 0.25) !important; }
  /deep/ .el-input {
    width: 200px;
  }
}
</style>

